import qs from "qs";
import apiClient from './apiClient';
import {InsertBaechaBlockDTO} from "../containers/BaechaGroupList/BaechaGroupList.interface";


const fetchGroupList = async () => {
	const response = await apiClient.get(`/api/admin/common/group/list`);
	return response.data;
}

const searchGroup = async (name: string) => {
	const query = qs.stringify({ name });
	const response = await apiClient.get(`/api/admin/common/group/search?${query}`);
	return response.data;
}

const getGroupRanking = async (groupId: string, rankingPeriod: string) => {
	const query = qs.stringify({ groupId, rankingPeriod });
	const response = await apiClient.get(`/api/admin/common/group/ranking?${query}`);
	return response.data;
}

const getGroupConfigs = async (groupId: string, keys?: string[]) => {
	const query = qs.stringify({ groupId, keys: [...(keys ?? []), 'config'] });
	const response = await apiClient.get(`/api/admin/common/group/rule?${query}`);
	return response.data;
}

const fetchGroupMemberList = async (groupId: string) => {
	const response = await apiClient.get(`/api/admin/common/member/list/${groupId}`);
	return response.data;
}

const getBaechaBlockListByGroupId = async (groupId: string) => {
	const query = qs.stringify({ groupId });
	const response = await apiClient.get(`/api/admin/common/baechaBlock/group/list?${query}`);
	return response.data;
}

const getBaechaBlockListByMemberId = async (memberId: string) => {
	const query = qs.stringify({ memberId });
	const response = await apiClient.get(`/api/admin/common/baechaBlock/member/list?${query}`);
	return response.data;
}

const getBaechaBlockListByUserId = async (userId: string) => {
	const query = qs.stringify({ userId });
	const response = await apiClient.get(`/api/admin/common/baechaBlock/user/list?${query}`);
	return response.data;
}


const insertGroupBaechaBlock = async (insertBaechaBlockDTO: InsertBaechaBlockDTO) => {
	const response = await apiClient.post(`/api/admin/common/baechaBlock`, insertBaechaBlockDTO);
	return response.data;
}

const deleteGroupBaechaBlock = async (id: string) => {
	const query = qs.stringify({ id });
	const response = await apiClient.delete(`/api/admin/common/baechaBlock?${query}`);
	return response.data;
}

const groupAPI = {
	fetchGroupList,
	searchGroup,
	getGroupRanking,
	getGroupConfigs,
	fetchGroupMemberList,
	getBaechaBlockListByGroupId,
	getBaechaBlockListByMemberId,
	getBaechaBlockListByUserId,
	insertGroupBaechaBlock,
	deleteGroupBaechaBlock,
};

export default groupAPI;
